<template>
  <div class="request-form">
    <h6 v-if="!submitting">Submit your request for additional insights</h6>
    <h6 v-else>We are sending your request to our team</h6>
    <div v-if="!submitted">
      <div class="steps" v-if="!submitting">
        <div class="step">
          <div class="question">
            <div class="step-index">
              <fa
                :icon="['far', 'check-circle']"
                v-if="confirmedSelectedIPs.length"
              ></fa>
              <div class="number" v-else>1</div>
            </div>
            <div class="title required">
              <div>
                <PrefixModal class="modal-link" />the list of offending IP
                addresses that you would like to receive further information on.
              </div>
            </div>
          </div>
        </div>
        <div class="step">
          <div class="question">
            <div class="step-index">
              <div class="number">2</div>
            </div>
            <div class="title">Type further details (Optional)</div>
          </div>
          <div class="input">
            <textarea
              name="detials"
              id="details"
              rows="6"
              placeholder="The more details you provide, the more efficient our response can be."
              v-model="message"
            ></textarea>
          </div>
        </div>
      </div>
      <Spinner v-else>Sending</Spinner>
      <div class="submit-btn">
        <button
          class="btn btn-primary"
          :class="{
            submitting: submitting,
            disabled: !confirmedSelectedIPs.length || submitting
          }"
          :disabled="!confirmedSelectedIPs.length || submitting"
          @click="onSubmit"
        >
          Submit request
        </button>
      </div>
    </div>
    <div class v-else>
      <Notification type="success" title="Request submitted successfully!">
        <p>
          We have sent you an email with the summary request and tracking
          number.
        </p>
        <p>The APNIC security team will contact you.</p>
      </Notification>

      <div class="resubmit-btn">
        <button class="btn btn-primary" @click="onReSubmit">
          Submit a new request for help
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PrefixModal from './PrefixModal';
import Notification from '../ui/Notification';
import mixin from '../../utils/helpMixin';
import Spinner from '../ui/Spinner';

export default {
  mixins: [mixin],
  components: {
    PrefixModal,
    Notification,
    Spinner
  },
  data() {
    return {
      showModal: false,
      message: ''
    };
  },
  watch: {
    selectedASN() {
      this.clearConfirmSelected();
    }
  },
  methods: {
    onSubmit() {
      this.submitForm({ message: this.message });
    },
    onReSubmit() {
      this.setSubmitted(false);
      this.message = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.request-form {
  padding-bottom: 20px;

  .step {
    margin-bottom: 10px;

    .question {
      display: flex;
      .step-index {
        width: 26px;
        height: 30px;
        margin-right: 9px;
        display: flex;
        align-items: center;
        .number {
          width: 26px;
          border-radius: 50%;
          color: #007bbd;
          border: 3px solid #007bbd;
          height: 26px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 700;
          line-height: 27px;
        }

        svg {
          font-size: 26px;
          color: $apnic-blue;
        }
      }

      .title {
        display: flex;
        align-items: center;
      }
    }
    .input {
      margin-left: 35px;
      input {
        min-width: 250px;
        font-size: 16px;
        @media screen and (max-width: 375px) {
          min-width: 205px;
        }
      }
      span {
        display: block;
        color: red;
        font-size: 12px;
      }
    }

    input,
    textarea {
      padding: 0 5px;
      &:focus {
        outline-color: $apnic-blue;
      }
    }
  }
  .required {
    &::after {
      content: '*';
      color: red;
    }
  }
  button.submitting {
    cursor: progress;
  }
}
textarea {
  width: 100%;
}

.modal-link {
  margin-right: 8px;
}

.spinner {
  margin-bottom: 16px;
}
</style>
